import { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'
import { getDashboardPath } from 'utils'

type RouteGuardProps = {
  children: ReactElement
  requiredRoles: string[]
}

function RouteGuard({ children, requiredRoles }: RouteGuardProps) {
  const { role, isLoggedIn } = useAuth()
  if (!isLoggedIn) {
    return <div>Loading...</div>
  }

  const currentRoles = role
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)

  const hasAccess = requiredRoles.some((requiredRole) =>
    currentRoles.some(
      (currentRole) =>
        currentRole === requiredRole || currentRole.includes(requiredRole)
    )
  )

  if (requiredRoles && !hasAccess) {
    return <Navigate to={getDashboardPath()} replace />
  }

  return children
}

export default RouteGuard
